import { Modal } from 'components/Modal';
import React from 'react';

import { IGenericModalProps } from './IGenericModalProps';
import ModalContent from './ModalContent';

export default function GenericModal(props: IGenericModalProps) {
  return <Modal onClose={props.onClose}>{(closeModal) => <ModalContent closeModal={closeModal} {...props} />}</Modal>;
}
